module.exports = __webpack_public_path__ + "static/aws-f84e74a44804042ae529c3c2a3d3fa93.png";